import { ApolloClient, gql } from '@apollo/client';
import { CategoriesQuery, StaticFooterDataQuery } from '../../graphql/graphql';
import { Cities } from './constants';
import { getStaticFooterData, getCategories } from '../../api/queries';

// Minimal query matching mock data fields for Apollo cache population in E2E
const CATEGORIES_CACHE_QUERY = gql`
  query Categories {
    categories {
      id
      name
      pluralName
      slug
      children {
        id
        name
        pluralName
        slug
      }
    }
  }
`;

interface StaticData {
  citiesUnPopularList: StaticFooterDataQuery['cities'];
  regions: { [cityId: string]: StaticFooterDataQuery['regions'] };
  categories: CategoriesQuery['categories'];
  error?: unknown;
}

export const getStaticData = async (
  apolloClient: ApolloClient<unknown>,
  withCategories = false
): Promise<StaticData> => {
  const locationVariables = { cityId: Cities.Baku.id };

  if (typeof window === 'undefined' && process.env.NEXT_PUBLIC_E2E === '1') {
    let categories: CategoriesQuery['categories'] = [];

    if (withCategories) {
      const { readMockFile } = await import('./readMockFile');
      const categoriesMock = await readMockFile<{
        data: { categories: CategoriesQuery['categories'] };
      }>('main_page/categoriesQueryMockData.json');
      categories = categoriesMock?.data?.categories || [];

      apolloClient.cache.writeQuery({
        query: CATEGORIES_CACHE_QUERY,
        data: { categories }
      });
    }

    return {
      citiesUnPopularList: [],
      regions: { [locationVariables.cityId]: [] },
      categories
    };
  }

  let categories = [];
  try {
    const { data } = await apolloClient.query<StaticFooterDataQuery>({
      query: getStaticFooterData
    });

    if (withCategories) {
      const { data: categoriesData } =
        await apolloClient.query<CategoriesQuery>({
          query: getCategories
        });
      categories = categoriesData?.categories || [];
    }

    return {
      citiesUnPopularList: data?.cities || [],
      regions: { [locationVariables.cityId]: data?.regions || [] },
      categories
    };
  } catch (e) {
    console.error(e);
    return {
      citiesUnPopularList: [],
      regions: { [locationVariables.cityId]: [] },
      error: JSON.stringify(e),
      categories: []
    };
  }
};
